/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneClassicIcon16Solid = forwardRef('TechPhoneClassicIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.331 6.026c.336 1.53 1.15 3.357 3.222 5.429s3.898 2.886 5.429 3.221c1.698.372 3.409-.432 4.638-1.661a1.11 1.11 0 0 0 0-1.57l-1.681-1.68a1.117 1.117 0 0 0-1.58 0c-.748.748-1.772 1.393-2.726.935-.53-.255-1.13-.712-1.871-1.454-.742-.742-1.2-1.341-1.454-1.871-.459-.954.187-1.978.935-2.726a1.117 1.117 0 0 0 0-1.58l-1.68-1.681a1.11 1.11 0 0 0-1.57 0C1.763 2.617.959 4.328 1.33 6.026Z" })));
});
